export const content = `Agent:,Joe Howard
Member of teams:,is_it_fixed_team
Date:,2021-11-07 00:00:00 +0100 - 2021-12-07 13:57:33 +0100

Daily Values:
"",Total Conversations,Likes,Reviews,Assigns,Resolved,Flow Mode,Reviews/Flow mode time,Resolve/Flow mode time
2021-11-07 from 00:00 to 23:59,0,0,0,0,0,00:00:00,-,-
2021-11-08 from 00:00 to 23:59,0,0,0,0,0,00:00:00,-,-
2021-11-09 from 00:00 to 23:59,0,0,0,0,0,00:00:00,-,-
2021-11-10 from 00:00 to 23:59,0,0,0,0,0,00:00:00,-,-
2021-11-11 from 00:00 to 23:59,0,0,0,0,0,00:00:00,-,-
2021-11-12 from 00:00 to 23:59,0,0,0,0,0,00:00:00,-,-
2021-11-13 from 00:00 to 23:59,0,0,0,0,0,00:00:00,-,-
2021-11-14 from 00:00 to 23:59,0,0,0,0,0,00:00:00,-,-
2021-11-15 from 00:00 to 23:59,0,0,0,0,0,00:00:00,-,-
2021-11-16 from 00:00 to 23:59,0,0,0,0,0,00:00:00,-,-
2021-11-17 from 00:00 to 23:59,0,0,0,0,0,00:00:00,-,-
2021-11-18 from 00:00 to 23:59,0,0,0,0,0,00:00:00,-,-
2021-11-19 from 00:00 to 23:59,0,0,0,0,0,00:00:00,-,-
2021-11-20 from 00:00 to 23:59,0,0,0,0,0,00:00:00,-,-
2021-11-21 from 00:00 to 23:59,0,0,0,0,0,00:00:00,-,-
2021-11-22 from 00:00 to 23:59,0,0,0,0,0,00:00:00,-,-
2021-11-23 from 00:00 to 23:59,0,0,0,0,0,00:00:00,-,-
2021-11-24 from 00:00 to 23:59,0,0,0,0,0,00:00:00,-,-
2021-11-25 from 00:00 to 23:59,0,0,0,0,0,00:00:00,-,-
2021-11-26 from 00:00 to 23:59,0,0,0,0,0,00:00:00,-,-
2021-11-27 from 00:00 to 23:59,0,0,0,0,0,00:00:00,-,-
2021-11-28 from 00:00 to 23:59,0,0,0,0,0,00:00:00,-,-
2021-11-29 from 00:00 to 23:59,0,0,0,0,0,00:00:00,-,-
2021-11-30 from 00:00 to 23:59,0,0,0,0,0,00:00:00,-,-
2021-12-01 from 00:00 to 23:59,0,0,0,0,0,00:00:00,-,-
2021-12-02 from 00:00 to 23:59,0,0,0,0,0,00:00:00,-,-
2021-12-03 from 00:00 to 23:59,0,0,0,0,0,00:00:00,-,-
2021-12-04 from 00:00 to 23:59,0,0,0,0,0,00:00:00,-,-
2021-12-05 from 00:00 to 23:59,0,0,0,0,0,00:00:00,-,-
2021-12-06 from 00:00 to 23:59,0,0,0,0,0,00:00:00,-,-
2021-12-07 from 00:00 to 13:57,0,0,0,0,0,00:00:00,-,-

Total Values:
"",Total Conversations,Likes,Reviews,Assigns,Resolved,Flow Mode,Reviews/Flow mode time,Resolve/Flow mode time
"",0,0,0,0,0,00:00:00,-,-

Legend:
Total Conversations - The total number of conversations that the user engaged with from the relevant sources in the chosen timeframe.
Likes - The total number of likes done by the user from the relevant sources in the chosen timeframe.
"Reviewed - The total number of items reviewed by the user from the relevant sources in the chosen timeframe. (This includes items that were automatically marked as reviewed when the ""Review on reply"" user setting is enabled.)"
Assigns - The total number of items assigned by the user from the relevant sources in the chosen timeframe
Resolved - The total number of items that were either replied to or reviewed by the user from the relevant sources in the chosen timeframe.
"Flow Mode - The total time spent by the user in Flow Mode, for all sources in the chosen timeframe."
"""Reviews/Flow mode time"" - Reviews per active time (flow mode time). This column displays the rate of actual reviewed items handling per minute. The reviewed items are reviews that occurred on the system."
"""Resolve/Flow mode time"" - Resolve per active time (flow mode time). This column displays the rate of actual resolved items handling per minute. The resolved items are resolved that occurred on the system."
`;
